module.exports = __webpack_public_path__ + "img/txsb.0f6060ea.png";